import { call, put, select } from 'redux-saga/effects';
import { fathomModel } from '../';
import {
  createNotification,
  snackbarModel,
} from '../../../../features/snackbar';
import { teamsModel } from '../../../../features/teams';
import { fathomApi } from '../../../../shared/api/axios/fathom';
import { RT } from '../../../../shared/types';

export function* connectToFathom({
  payload: { apiKey, cb },
}: ReturnType<typeof fathomModel.actions.connectToFathom>) {
  yield put(fathomModel.actions.setIsConnecting(true));

  try {
    const currentTeam: RT<
      typeof teamsModel.selectors.selectCurrentTeamWithError
    > = yield select(teamsModel.selectors.selectCurrentTeamWithError);

    yield call(fathomApi.connectToFathom, currentTeam.id, { apiKey });

    yield call(teamsModel.sagas.refreshTeamsData);

    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('success', 'Successfully connected to Fathom')
      )
    );

    yield put(fathomModel.actions.getTranscripts());

    cb();
  } catch (error) {
    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('error', 'Error connecting to Fathom')
      )
    );
  } finally {
    yield put(fathomModel.actions.setIsConnecting(false));
  }
}
